import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useContext } from 'react';

import image from '@/assets/images/system-not-available.svg';
import HealthStatusContext from '@/context/HealthStatusContext/HealthStatusContext';
import { STATUS_YLAH_URL } from '@/utils/constans';

import styles from './HealthStatusOverlay.module.scss';

export function HealthStatusOverlay() {
  const { t } = useTranslation('common');
  const { pathname } = useRouter();
  const { areSystemsAvailable, isPending } = useContext(HealthStatusContext);

  if (
    areSystemsAvailable ||
    isPending ||
    ['/welcome', '/503'].includes(pathname)
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.tile} role="alert" aria-live="assertive">
        <h1 className={styles.header}>
          {t('system-not-available-modal.header')}
        </h1>
        <div className={styles.content}>
          <p className={styles.message}>
            {t('common:system-not-available-modal.message')}{' '}
            {t('common:system-not-available-modal.try-again-later')}{' '}
            <Link
              href={STATUS_YLAH_URL}
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              {t('common:system-not-available-modal.url-label')}
            </Link>
          </p>
          <Image src={image} alt="" />
        </div>
      </div>
    </div>
  );
}
